module.exports = __webpack_public_path__ + "img/icon_23years_en.f5244579.png";